import { ERD, VpnAccountActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import {
  VPN_ACCOUNT_ENDPOINTS_URLS,
  VPN_ACCOUNT_TAGS,
} from "./api-vpn-account.constant";

export const {
  useCreateVpnAccountMutation,
  useReadManyVpnAccountsQuery,
  useDeleteVpnAccountMutation,
  useImportVpnAccountsMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    createVpnAccount: builder.mutation<
      ERD<VpnAccountActions["create"]>,
      QueryArgsNew<VpnAccountActions["create"]>
    >({
      query: ({ payload }) => ({
        url: VPN_ACCOUNT_ENDPOINTS_URLS.create,
        method: "post",
        payload,
      }),
      invalidatesTags: [VPN_ACCOUNT_TAGS.vpnAccount],
    }),
    readManyVpnAccounts: builder.query<
      ERD<VpnAccountActions["readMany"]>,
      QueryArgsNew<VpnAccountActions["readMany"]>
    >({
      query: ({ query }) => ({
        url: VPN_ACCOUNT_ENDPOINTS_URLS.readMany,
        method: "get",
        query,
      }),
      providesTags: [VPN_ACCOUNT_TAGS.vpnAccount],
    }),
    deleteVpnAccount: builder.mutation<
      void,
      QueryArgsNew<VpnAccountActions["delete"]>
    >({
      query: ({ params }) => ({
        url: VPN_ACCOUNT_ENDPOINTS_URLS.delete(params),
        method: "delete",
      }),
      invalidatesTags: [VPN_ACCOUNT_TAGS.vpnAccount],
    }),
    importVpnAccounts: builder.mutation<
      ERD<VpnAccountActions["import"]>,
      { file: File }
    >({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: VPN_ACCOUNT_ENDPOINTS_URLS.import,
          method: "post",
          body: formData,
        };
      },
      invalidatesTags: [VPN_ACCOUNT_TAGS.vpnAccount],
    }),
  }),
});

export const downloadVpnAccountTemplate = async () => {
  const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:6002";
  const accessToken = localStorage.getItem("token");
  const response = await fetch(`${apiUrl}/${VPN_ACCOUNT_ENDPOINTS_URLS.importTemplate}`, {
    headers: { Authorization: accessToken || "" },
  });
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "vpn-accounts-template.xlsx";
  link.click();
  window.URL.revokeObjectURL(url);
};

export const downloadVpnAccountsExport = async (type: "vmess" | "ssh") => {
  const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:6002";
  const accessToken = localStorage.getItem("token");
  const response = await fetch(`${apiUrl}/${VPN_ACCOUNT_ENDPOINTS_URLS.export(type)}`, {
    headers: { Authorization: accessToken || "" },
  });
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `vpn-accounts-${type}.xlsx`;
  link.click();
  window.URL.revokeObjectURL(url);
};
